module.exports = __webpack_public_path__ + "img/footer-bg.33b4be57.jpg";